import React from 'react';

import MenuItem from '@gogame/ui/MenuItem';
import Stack from '@gogame/ui/Stack';
import { ArrowUpwardIcon, ArrowDownwardIcon } from '@gogame/ui/Icon';

function getDirection(orderDir) {
  return orderDir ? { desc: 'asc', asc: 'desc' }[orderDir] : 'asc';
}

const SortingItem = ({ children, selected, onChange, orderDir }) => {
  const handleChange = () => {
    onChange(getDirection(orderDir));
  };
  return (
    <MenuItem selected={selected} onClick={handleChange}>
      <Stack width={'100%'} direction={'row'} alignItems={'center'} spacing={1}>
        <Stack width={24} direction={'row'} alignItems={'center'}>
          {selected ? (
            orderDir === 'asc' ? (
              <ArrowUpwardIcon color={'action'} />
            ) : (
              <ArrowDownwardIcon color={'action'} />
            )
          ) : null}
        </Stack>
        <span>{children}</span>
      </Stack>
    </MenuItem>
  );
};
export default SortingItem;
